import { Animator } from "../Common/Animator";
import { Apps } from "./Apps";
import { Boost } from "./Boost";

import '../../styles/Create.css';

export function Create({ apps, boost}) {
  return(
    <div id="create">
      <section className="hero is-small is-success">
        <div className="hero-body">
          <h2 className="subtitle is-2 bf-sub-title">Producimos</h2>
        </div>
      </section>
      
      <div>
        <section className="hero is-primary">
          <div className="hero-body pb-0">
            <Animator 
              component={<Apps apps={apps}/>}
            />
          </div>
        </section>

        <section className="hero is-primary">
          <div className="hero-body pt-0">
            <Animator 
              component={<Boost boost={boost}/>}
            />
          </div>
        </section>
      </div>

    </div>
  );
}